import Header from "layout/header"
import Head from "next/head"
import { FC, ReactNode } from "react"
import IBehsaPageConfig from "rules/interface/config/behsa-config.interface"
import FooterBehsaLanding from "./footer"
import styles from "./index.module.scss"


interface IProps {
    children: ReactNode
    config: IBehsaPageConfig
}


const BehsaLandingLayout: FC<IProps> = ({ children }) => {

    return (
        <>
            <Head>
                <title>سلام ساختمان</title>
                <meta name="description" content="بزرگترین بازار آنلاین طراحی و سفارش انواع کابینت و کمد دیواری، معرفی بهترین کابینت سازها در سراسر ایران، تضمین کیفیت و قیمت" />
            </Head>

            <section className={styles.behsa_landing}>
                <Header />

                <section>
                    {children}
                </section>


                <FooterBehsaLanding />
            </section>

        </>
    )
}


export default BehsaLandingLayout